import dayjs from 'dayjs'

export function castDateFull(date) {
  // return date format
  return dayjs(date).format('MMMM Do, YYYY')
}
